/**
 * Generated runtime TestId mirror for frontend/src/components/ui/calendar.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const CalendarTestIds = {
  calendarLabel: "calendar-label",
  calendarNextDecade: "calendar-next-decade",
  calendarNextMonth: "calendar-next-month",
  calendarNextYear: "calendar-next-year",
  calendarPrevDecade: "calendar-prev-decade",
  calendarPrevMonth: "calendar-prev-month",
  calendarPrevYear: "calendar-prev-year",
  calendarYearRange: "calendar-year-range",
  calendarDay: (iso: string) => `calendar-day-${iso}`,
  calendarDayPrefix: () => "calendar-day-" as TestIdPrefix,
  calendarYear: (year: string) => `calendar-year-${year}`,
  calendarYearPrefix: () => "calendar-year-" as TestIdPrefix
} as const;
